module.exports = __webpack_public_path__ + "img/15-4.2a64409c.jpg";